import { FormsModule } from '@angular/forms';
import { ExibeErroComponent } from "./exibe-erro.component";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

@NgModule({
  declarations: [ExibeErroComponent],
  imports: [CommonModule, FormsModule],
  providers: [],
  exports: [ExibeErroComponent]
})
export class ExibeErroModule {}
